// removed by extract-text-webpack-plugin
module.exports = {"mainNav":"MainNav__mainNav___2RzWL","batch":"MainNav__batch___1WL7F","isHighlighted":"MainNav__isHighlighted___2FqaC","isHiddenMobile":"MainNav__isHiddenMobile___2yqEA","isActive":"MainNav__isActive___2AWpm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/MainNav/MainNav.scss
// module id = 637
// module chunks = 0